<!-- Header -->
<app-gc-header [titleString]="'title' | translate" [iconName]="'graph'" />

@if (loadingState$ | async; as loadingState) {
  @if (initialProjects$ | async; as initialProjects) {
    <ipo-tabs
      [activeTabId]="tab"
      class="tabs"
      (activeTabIdChanged)="onActiveTabChanged($event)"
    >
      <ipo-tab
        [tabTitle]="'tabs.all' | translate"
        [id]="deliveryOverviewTabs.All"
      >
        @if (loadingState.isLoading) {
          <div>
            <ipo-loading-spinner></ipo-loading-spinner>
          </div>
        }

        @if (tab === deliveryOverviewTabs.All) {
          @if (loadingState.hasLoaded && initialProjects.length > 0) {
            <div>
              <ng-container>
                <div class="wrapper">
                  <div class="filter">
                    <app-delivery-overview-search></app-delivery-overview-search>
                  </div>

                  @if (hasNoProjectMatches()) {
                    <div class="no-search-matches">
                      <p>No projects match your search.</p>

                      @if (canCreateIfs) {
                        <gc-button
                          [disabled]="isCreatingIfs()"
                          (clicked)="createIfs()"
                        >
                          @if (isCreatingIfs()) {
                            Creating IFS...
                          } @else {
                            Create IFS
                          }
                        </gc-button>
                      }
                    </div>
                  } @else {
                    <div class="table">
                      <app-delivery-overview-table
                        [activeTab]="tab"
                        [projects]="(projects$ | async)!"
                      ></app-delivery-overview-table>
                    </div>
                  }
                </div>
              </ng-container>
            </div>
          }

          @if (
            (loadingState.hasLoaded &&
              !loadingState.isLoading &&
              initialProjects.length === 0) ||
            loadingState.hasError
          ) {
            <div class="no-projects">
              <p>
                {{ 'table.noProjects' | translate }}
              </p>
            </div>
          }
        }
      </ipo-tab>

      <ipo-tab
        [tabTitle]="'tabs.starred' | translate"
        [id]="deliveryOverviewTabs.Starred"
        class="tab"
      >
        @if (loadingState.isLoading) {
          <div>
            <ipo-loading-spinner></ipo-loading-spinner>
          </div>
        } @else {
          @if (tab === deliveryOverviewTabs.Starred) {
            @if (starredProjects$ | async; as starredProjects) {
              <div>
                @if (starredProjects.length > 0) {
                  <div class="wrapper">
                    <div class="search-and-info-wrapper">
                      <div class="filter">
                        <app-delivery-overview-search></app-delivery-overview-search>
                      </div>

                      <div class="information-box">
                        <gc-icon
                          iconName="circleQuestion"
                          size="small"
                        ></gc-icon>

                        <gc-text>{{ 'informationBox' | translate }}</gc-text>
                      </div>
                    </div>

                    <div class="table">
                      <app-delivery-overview-table
                        [activeTab]="tab"
                        [projects]="starredProjects"
                      ></app-delivery-overview-table>
                    </div>
                  </div>
                } @else {
                  <div class="no-projects">
                    <p>
                      {{ 'table.noStarredProjects' | translate }}
                    </p>
                  </div>
                }
              </div>
            }
          }
        }
      </ipo-tab>
    </ipo-tabs>
  }
}
